// This is required for the embedded layout to load the correct assets.
// eslint-disable-next-line no-undef -- webpack magic global, injected at bundle time
__webpack_public_path__ = process.env.REACT_APP_ASSET_PATH || '/';
